module.exports = __webpack_public_path__ + "static/img/app6.221b139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app6.jpg
// module id = Zjyq
// module chunks = 1